import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-yellow bg-brand-navy" data-id="element-97" data-mp="4mi5dgdtryh4">
      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-98" data-mp="1297c23jh2z9b">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full bg-brand-blue px-3 py-1 font-display text-[0.62rem] font-bold uppercase tracking-[0.12em] text-white" data-id="element-99" data-mp="1274nzp1vrg78">
          <GraduationCapIcon size={12} data-id="element-100" data-mp="3d21uc37gquqd" />
          Método de enseñanza paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 font-display text-[1.4rem] font-black uppercase leading-[1.08] text-white sm:text-3xl" data-id="element-101" data-mp="381xjaspbqs7j">
          El sistema completo para enseñar{' '}
          <span className="text-brand-yellow" data-id="element-102" data-mp="39a362wh917l7">Arduino y Robótica</span> con
          material listo para usar
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-white/85 sm:text-[0.92rem]" data-id="element-103" data-mp="30i18r72h87f5">
          Enseña Arduino, programación, sensores, automatización y robótica con
          una ruta organizada y recursos prácticos para tus clases — sin perder
          horas buscando actividades, proyectos y material disperso.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-2 inline-block rounded-md bg-brand-yellow px-3 py-1.5 font-display text-[0.65rem] font-black uppercase leading-tight tracking-wide text-brand-night sm:text-xs" data-id="element-104" data-mp="2ll0eavswhycz">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-2 block overflow-hidden rounded-xl border-4 border-brand-yellow bg-white" data-id="element-105" data-mp="deyke41ik3c4">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-106" data-mp="114stcaipp7r3" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-107" data-mp="3lu9x916uryb8">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-108" data-mp="1x784pmxv7ptl">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-white/85" data-id="element-109" data-mp="269zihte7qxoe">
            <span className="flex items-center gap-1" data-id="element-110" data-mp="2b0ze8vblj9pb">
              <ZapIcon size={12} className="text-brand-yellow" data-id="element-111" data-mp="2b2k9kn5qiwo8" />
              Acceso Digital Inmediato
            </span>
            <span className="text-white/50" data-id="element-112" data-mp="2kyn9rnh10l8j">•</span>
            <span className="flex items-center gap-1" data-id="element-113" data-mp="2kxc7js38bljj">
              <ShieldCheckIcon size={12} className="text-[#3FD08F]" data-id="element-114" data-mp="2ozz4g7erbwnl" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}